import React from 'react';
import { ProgressStateModel, LiveStreamErrorType, LiveStreamOperatorType } from 'eTip--common';
import { Loader, MatchTrackerPlayer } from 'common--design-library';
import { translation } from 'easit--localization';
import { NoResultsCustom } from '../../common/noResults/noResults';

interface IMatchTrackerProps {
    state: ProgressStateModel;
    errorMessage?: string;
    externalId: string;
    operator: LiveStreamOperatorType;
    eventName: string;
    languageId: string;
    elementIdBase: string;

    matchTrackerKey: string;

    prepareUrlsAsync: () => void;
    errorLoadingContent: (errorType: LiveStreamErrorType) => void;
    shownForMonitoring: () => void;
    stoppedForMonitoring: () => void;
}

export const MatchTracker = (props: IMatchTrackerProps) => {
    return (
        <div className="liveStreamWrapper mb-3"
            style={props.state == ProgressStateModel.Failed ? {} : { minHeight: "345px" /* not to resize during load, ad hoc value */ }}
        >
            {
                props.state == ProgressStateModel.Loading && <Loader text={translation().liveStream_Opening} className="p-3"></Loader>
            }
            {
                props.state == ProgressStateModel.Failed && <NoResultsCustom message={props.errorMessage}>
                    <button className="btn btn-primary btn-sm ml-3" onClick={() => { props.prepareUrlsAsync(); }}>
                        {translation().liveStream_TryAgain}
                    </button>
                </NoResultsCustom>
            }
            {
                props.state === ProgressStateModel.Success && <MatchTrackerPlayer
                    externalId={props.externalId}
                    operator={props.operator}
                    eventName={props.eventName}
                    /*asStats={props.showType === LiveStreamShowType.Stats}*/
                    errorLoadingContent={(errorType: LiveStreamErrorType) => props.errorLoadingContent(errorType)}
                    elementId={`${props.elementIdBase}-${props.externalId}`}
                    languageId={props.languageId}
                    canFixHeightOnLoad={false}

                    matchTrackerKey={props.matchTrackerKey}

                    shownForMonitoring={() => { props.shownForMonitoring(); }}
                    stoppedForMonitoring={() => { props.stoppedForMonitoring(); }}
                />
            }
        </div>
    )
}